import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Loading from '../Loader/Loader';
import '../../assets/css/BankIDConsent.css';
import BankIDlogoImage from '../../assets/images/BankIDlogoImage.svg';

const BankIDConsent = () => {
  const { t, i18n } = useTranslation('common');
  const dispatch = useDispatch();
  const location = useLocation();

  const signingUrl = location.state?.signingUrl;
  const languageCode = location.state?.LanguageCode;



  useEffect(() => {
    if (languageCode) {
      if (languageCode === 1033) {
        i18n.changeLanguage('en');
      } else if (languageCode === 1044) {
        i18n.changeLanguage('no');
      }
    }
  }, [languageCode, i18n]);

  const handleContinue = () => {
    if (signingUrl) {
      window.location.href = signingUrl;
    }
  };
  return (
    <div className="bankid-page">
      <div className="bankid-header">
        <img
          src={BankIDlogoImage}
          alt="BankID"
          className="bankid-logo"
        />
      </div>

      <div className="bankid-center bankid-layout">
        <div className="bankid-card">

          <div className="bankid-top-row">
            <span className="bankid-small-text">
              {t('esign.bankidUsingText')}
            </span>
          </div>

          <div className="bankid-info-box">
            <h2 className="bankid-info-title">
              {t('esign.bankidConsentMessage')}
            </h2>
          </div>

          <button
            className="bankid-primary-btn"
            onClick={handleContinue}
          >
            {t('esign.bankidContinueBtn')}
          </button>

          <button
            className="bankid-cancel-btn"
            onClick={() => window.close()}
          >
            {t('esign.bankidCancelBtn')}
          </button>

        </div>
      </div>
    </div>
  );
};

export default BankIDConsent;